// 应用全局配置
const config = {
  // baseUrl: 'http://api-dashboard.yudao.iocoder.cn',
  baseUrl: 'http://192.168.11.172:48080',
  // baseUrl: 'http://192.168.11.172/',
  baseApi: '/admin-api',
  // 应用信息
  appInfo: {
    // 应用名称
    name: "一站通",
    // 应用版本
    version: "1.0.0",
    // 应用logo
    logo: "@/static/logo.png",
    // 官方网站
    site_url: "https://iocoder.cn",
    // 政策协议
    agreements: [{
      title: "隐私政策",
      url: "https://iocoder.cn"
    },
    {
      title: "用户服务协议",
      url: "https://iocoder.cn"
    }
    ]
  }
}

export default config
